import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthRedirectService {
  private readonly storageKey = 'oneray-auth-redirect-url';

  public sanitize(url: string | null | undefined): string | null {
    if (!url || url === '/' || !url.startsWith('/') || url.startsWith('//') || url.startsWith('/auth/')) {
      return null;
    }

    return url;
  }

  public save(url: string | null | undefined): void {
    const sanitizedUrl = this.sanitize(url);

    if (!sanitizedUrl) {
      this.clear();
      return;
    }

    this.getStorage()?.setItem(this.storageKey, sanitizedUrl);
  }

  public consume(): string | null {
    const redirectUrl = this.sanitize(this.getStorage()?.getItem(this.storageKey));
    this.clear();

    return redirectUrl;
  }

  public clear(): void {
    this.getStorage()?.removeItem(this.storageKey);
  }

  private getStorage(): Storage | null {
    try {
      return window.sessionStorage;
    } catch {
      return null;
    }
  }
}
